import type { Observable } from 'rxjs';
import type { CrmDeal } from '@integrations/crm-deals/contracts/crm-deal.contract';

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CRM_SERVICE_API_BASE } from '@integrations/crm-pipelines';
import { parseResponse } from '@integrations/shared/parse-response';
import { CrmDealCollectionResponseSchema } from '@integrations/crm-deals/contracts/crm-deal.contract';

@Injectable({ providedIn: 'root' })
export class CrmDealsApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = inject(CRM_SERVICE_API_BASE);

    public getDealsAttributes(pipelineId: number): Observable<CrmDeal[]> {
        return this.http.get<unknown>(`${this.baseUrl}/deals/attributes/${pipelineId}`).pipe(
            map(
                (res) =>
                    parseResponse(res, CrmDealCollectionResponseSchema, {
                        endpoint: 'crm/deals/attributes',
                        method: 'GET',
                    }).data
            )
        );
    }
}
